<template>
  <div class="border-section">
    <span>
      <span class="border-section__title" v-if="title">{{ title }}</span>
      {{ sectionTitle }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SorabanSectionHeader',
  props: {
    title: {
      required: false,
      default: null,
      type: String,
    },
    sectionTitle: {
      required: true,
      type: String,
    },
  },
};
</script>
<style scoped lang="postcss">
.border-section {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: stretch;
  margin: 20px auto;
}

.border-section:after,
.border-section:before {
  content: '';
  flex: 1 1 auto;
  background-color: var(--color-grey--pale);
}

.border-section * {
  letter-spacing: 0.05em;
}

.border-section > span {
  margin-left: 10px;
  margin-right: 10px;
  font-size: var(--type-border-title);
  text-transform: uppercase;
  color: var(--color-grey--dark);
  font-weight: 600;
}

.border-section__title {
  border-right: solid 1px var(--color-grey);
  font-weight: 900;
  margin-right: 5px;
  padding-right: 7px;
}
</style>
